import axios from "axios"
// axios.defaults.baseURL = 'http://47.103.28.232:1688'; //配置接口地址 
axios.defaults.baseURL = 'http://139.196.222.92:9300'; //正式
// axios.defaults.baseURL = 'http://127.0.0.1:1688'; //配置接口地址
// axios.defaults.baseURL = 'http://10.10.0.210:9300'; //本地接口  浩
export function postAction(url, parmas) {
    return new Promise((resolve, reject) => {
        axios.post(url, parmas).then(res => {
            resolve(res.data)
        }, err => {
            reject(err)
        })
    })
}
export function getAction(url, parmas) {
    return new Promise((resolve, reject) => {
        axios.get(url, { params: parmas }).then(res => {
            resolve(res.data)
        }, err => {
            reject(err)
        })
    })
}
